module.exports = __webpack_public_path__ + "img/icon_updates.79347801.svg";